import React from 'react';
import { useTranslation } from 'react-i18next';

import { RegularButton } from 'pg-ui-library';

import { IBenefit } from 'src/interfaces';

import { EmptySettingsFormContainer, FormItem, SubmitContainer } from './styles';

export const EmptySettingsForm: React.FC<{
  benefit: IBenefit;
  // eslint-disable-next-line no-unused-vars
  onSubmit: (benefit: IBenefit) => void;
}> = ({ benefit, onSubmit }) => {
  const { t } = useTranslation();

  onSubmit(benefit);

  return (
    <EmptySettingsFormContainer>
      <FormItem>
        <p>{t('benefits.emptySettingsForm.title')}</p>
      </FormItem>
      <SubmitContainer>
        <RegularButton style={{ margin: '0 3px 0 0' }} type="submit" onClick={() => onSubmit(benefit)}>
          {t('global.form.submit')}
        </RegularButton>
      </SubmitContainer>
    </EmptySettingsFormContainer>
  );
};
